<template>
  <select :class="getClass(true)" name="year" :value="itemStore.year" @change="updateYear">
    <option value="0">{{ t("year") }}</option>
    <option v-for="year in itemStore.months" :value="year.year" :key="year.year">
      {{ year.year }}
    </option>
  </select>
  <select
    :class="getClass(false)"
    name="month"
    :value="itemStore.month"
    :disabled="itemStore.getMonths.length === 0"
    @change="updateMonth"
  >
    <option value="0">{{ t("month") }}</option>
    <option v-for="month in itemStore.getMonths" :value="month" :key="month">
      {{ getMonth(month) }}
    </option>
  </select>
</template>

<script setup lang="ts">
import { useItemStore } from "@/itemStore";
import { months } from "@/locales";

import { useI18n } from "vue-i18n";

const itemStore = useItemStore();
const { t } = useI18n();

const getClass = (year: boolean) => {
  let className = "btn";
  if ((year && itemStore.year > 0) || (!year && itemStore.month > 0)) {
    className += " active";
  }
  return className;
};

const getMonth = (month: number) => {
  return months(itemStore.lang)[month];
};

const updateYear = (event: Event) => {
  const target = event?.currentTarget as HTMLSelectElement;
  const value = Number(target.value);
  itemStore.setYear(value);
  console.debug(itemStore);
};

const updateMonth = (event: Event) => {
  const target = event?.currentTarget as HTMLSelectElement;
  const value = Number(target.value);
  itemStore.setMonth(value);
  console.debug(itemStore);
};
</script>
